import React from "react"

const CONFIRM_CONFIG = {
  skip: {
    title: "Skip this attempt?",
    text: "This will use one of your attempts without guessing. You'll still unlock the next hint.",
    confirmLabel: "Skip",
    btnClass: "gs-confirm-btn--skip",
  },
  surrender: {
    title: "Surrender?",
    text: "This will end the game and reveal the correct answer. You won't be able to guess again today.",
    confirmLabel: "Surrender",
    btnClass: "gs-confirm-btn--surrender",
  },
}

const ConfirmDialog = React.memo(function ConfirmDialog({ type, onConfirm, onCancel }) {
  const cfg = CONFIRM_CONFIG[type]
  if (!cfg) return null
  return (
    <div className="gs-confirm-overlay" onClick={onCancel}>
      <div className="gs-confirm-dialog" onClick={e => e.stopPropagation()}>
        <h3 className="gs-confirm-title">{cfg.title}</h3>
        <p className="gs-confirm-text">{cfg.text}</p>
        <div className="gs-confirm-actions">
          <button className="gs-confirm-btn gs-confirm-btn--cancel" onClick={onCancel}>Cancel</button>
          <button className={`gs-confirm-btn ${cfg.btnClass}`} onClick={onConfirm}>{cfg.confirmLabel}</button>
        </div>
      </div>
    </div>
  )
})

export default ConfirmDialog
